module.exports = __webpack_public_path__ + "media/images/errors/500-837c0596320e15ce18ee1eb3bcb87c3c.svg";